import _ from 'lodash';
import WebStoragePolyfill from './webstorage-polyfill';

const KEY = 'user-history';
const LIMIT = 8;

export default [
  '$window',
  class CampaignHistory {
    constructor($window, webstorage = new WebStoragePolyfill()) {
      this._$window = $window;
      this._storage = webstorage;
      this._history = [];
      this._loadHistory();
    }

    getHistory(limit) {
      let history = _.sortBy(this._history, (item) => -item.viewed);
      if (typeof limit === 'number') {
        history = history.slice(0, limit);
      }

      return history;
    }

    addItem(campaign, item) {
      let newItem = {
        viewed: (new Date()).getTime(),
        id: campaign.id,
        name: campaign.name,
        category: {
          name: campaign.category.name,
          id: campaign.category.id
        },
        image: item.default_side_to_display === 'BACK' ? item.assets.back_display_url : item.assets.front_display_url,
        uri: `${campaign.creator.user_info.public_name}/${campaign.slug}`,
        price: item.selling_price
      };

      _.remove(this._history, {
        id: newItem.id
      }); // Remove by ID
      _.remove(this._history, {
        name: newItem.name
      }); // Remove by campaign name
      this._history.push(newItem);
      this._saveHistory();
    }

    clear() {
      this._storage.removeLocalItem(KEY);
    }

    _loadHistory() {
      this._history = JSON.parse(this._storage.getLocalItem(KEY)) || [];
    }

    _saveHistory() {
      let history = _.sortBy(this._history, (item) => -item.viewed).slice(0, LIMIT);
      this._storage.setLocalItem(KEY, JSON.stringify(history));
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/data-providers/campaign-history.js